'use client';

import { useState } from 'react';
import PopTopicProvider from '@fe-news/context/pop-topic-provider';
import PopTopicFilter from '@fe-news/components/molecules/PopTopicFilter';
import PopTopicList from '@fe-news/components/molecules/PopTopicList/lazy';
import PopTopicTimeline from '@fe-news/components/molecules/PopTopicTimeline/lazy';
import { PopTopicTab, GTMConstants, PopTopicTabNames } from '@fe-news/constants/pop-topic/type';
import DateProvider from '@fe-news/context/date-provider';
import { NewsCategory } from '@fe-news/constants/categories';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

const sendGTMEvent = (tab: PopTopicTab) => {
  const item = tab === PopTopicTab.PopTopic ? PopTopicTabNames.PopTopic : PopTopicTabNames.Timeline;

  sendGTM({
    [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_TAB,
    [GTMEventKey.SECTION]: GTMConstants.NEWS_CATEGORY_POP_TOPIC,
    [GTMEventKey.CLICK_ITEM]: `${item}`
  });
};

const PopTopicContent = () => {
  const [current, setCurrent] = useState<PopTopicTab>(PopTopicTab.PopTopic);

  const onClickTab = (tab: PopTopicTab) => {
    setCurrent(tab);
    sendGTMEvent(tab);
  };

  return (
    <PopTopicProvider>
      <PopTopicFilter tab={current} onClickTab={onClickTab} />
      {current === PopTopicTab.PopTopic && <PopTopicList tab={current} onClickTab={onClickTab} />}
      {current === PopTopicTab.Timeline && (
        <DateProvider category={NewsCategory.POP_TOPIC}>
          <PopTopicTimeline />
        </DateProvider>
      )}
    </PopTopicProvider>
  );
};

export default PopTopicContent;
